document.addEventListener("DOMContentLoaded", function() {
    // --- Part 1: 配達日時ブロックのHTMLを記憶し、ページから削除 ---
    const sourceWrapper = document.querySelector("#deliveryDate__wrapper");
    if (!sourceWrapper) return;
    const deliveryElementClone = sourceWrapper.cloneNode(true);
    sourceWrapper.remove();

    // --- Part 2: 要素の配置と機能の初期化を行う関数 ---
    function setupDeliveryOptions() {
        const insertParent = document.querySelector(".Cart__Recap");
        const insertPosition = document.querySelector(".Cart__Checkout");

        if (!insertParent || !insertPosition) return;
        if (document.querySelector("#deliveryDate__wrapper")) return;

        insertParent.insertBefore(deliveryElementClone, insertPosition);

        const dateInput = document.querySelector('#date');
        const timeInput = document.querySelector('#time');
        const noteInput = document.querySelector('#cart-note');

        if (!dateInput || dateInput.dataset.listenerAttached === 'true') return;

        // --- データ送信機能 ---
        function updateCartAttributes() {
            const noteValue = noteInput ? noteInput.value : '';
            fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({
                    attributes: {
                        'delivery_date': dateInput.value,
                        'delivery_time': timeInput.value
                    },
                    note: noteValue
                })
            });
        }
        
        // --- 読み込み時に既存の値を検証する機能 ---
        const existingValue = dateInput.value;
        const minDateDays = parseInt(dateInput.dataset.minDate, 10);

        if (existingValue && !isNaN(minDateDays)) {
            const existingDate = new Date(existingValue);
            existingDate.setHours(0, 0, 0, 0);

            const minSelectableDate = new Date();
            minSelectableDate.setHours(0, 0, 0, 0);
            minSelectableDate.setDate(minSelectableDate.getDate() + minDateDays);
            
            if (existingDate < minSelectableDate) {
                dateInput.value = '';
                updateCartAttributes();
            }
        }

        // --- イベントリスナーとカレンダーの初期化 ---
        timeInput.addEventListener('change', updateCartAttributes);
        dateInput.addEventListener('change', updateCartAttributes);
        dateInput.dataset.listenerAttached = 'true';

        if (typeof jQuery !== 'undefined' && typeof jQuery.ui !== 'undefined' && typeof jQuery.ui.datepicker !== 'undefined') {
            (function($) {
                $.datepicker.setDefaults($.datepicker.regional["ja"]);
                var setCalsClearButton = function(year, month, elem) {
                    var afterShow = (function() {
                        var d = new $.Deferred();
                        var cnt = 0;
                        var timer = setInterval(function() {
                            if (elem.dpDiv && elem.dpDiv.is(':visible')) {
                                clearInterval(timer);
                                d.resolve();
                            } else if (cnt > 50) {
                                clearInterval(timer);
                                d.reject();
                            }
                            cnt++;
                        }, 10);
                        return d.promise();
                    })();
                    afterShow.done(function() {
                        $('.ui-datepicker').css('z-index', 2000);
                        var buttonPane = $(elem).datepicker("widget").find(".ui-datepicker-buttonpane");
                        if (buttonPane.find('.date_btn').length === 0) {
                            var btn = $('<button class="date_btn ui-datepicker-current ui-state-default ui-priority-primary ui-corner-all" type="button">指定無し</button>');
                            btn.off("click").on("click", function() {
                                $.datepicker._clearDate(elem.input[0]);
                                updateCartAttributes();
                            });
                            btn.appendTo(buttonPane);
                        }
                    });
                };
                
                // ★★★ 元々の祝日対応コードをここに統合 ★★★
                $.get("https://holidays-jp.github.io/api/v1/date.json", function(holidaysData) {
                    $("#date").datepicker({
                        minDate: minDateDays,
                        maxDate: '+2M',
                        showButtonPanel: true,
                        showMonthAfterYear: true,
                        monthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                        dayNames: ['日', '月', '火', '水', '木', '金', '土'],
                        dayNamesMin: ['日', '月', '火', '水', '木', '金', '土'],
                        dateFormat: "yy/mm/dd",
                        closeText: "閉じる",
                        beforeShowDay: function(date) {
                            var dateString = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
                            if (holidaysData[dateString]) {
                                return [true, 'custom-calendar-holiday', holidaysData[dateString]];
                            }
                            if (date.getDay() === 0) {
                                return [true, "custom-calendar-sunday", ""];
                            }
                            if (date.getDay() === 6) {
                                return [true, "custom-calendar-saturday", ""];
                            }
                            return [true, 'custom-calendar-weekday', null];
                        },
                        onSelect: function(dateText) {
                            dateInput.value = dateText;
                            updateCartAttributes();
                        },
                        beforeShow: function(inst, elem) { setCalsClearButton(null, null, elem); },
                        onChangeMonthYear: setCalsClearButton
                    });
                });
            })(jQuery);
        } else {
            setTimeout(setupDeliveryOptions, 200);
        }
    }

    // --- Part 5: カートの更新を監視 ---
    const target = document.querySelector(".PageContent");
    if (target) {
        const observer = new MutationObserver(setupDeliveryOptions);
        observer.observe(target, { childList: true, subtree: true });
    }
    setupDeliveryOptions();
});